import React from 'react';
import type { CableRouting } from '../../types';

function StraightIcon() {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden="true">
      <line x1="1" y1="5" x2="13" y2="5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

function FlexiIcon() {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden="true">
      <path
        d="M1 8 Q 7 1, 13 8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function CableRunRoutingPopover({
  onSelect,
}: {
  onSelect: (routing: CableRouting) => void;
}) {
  const options: Array<{ id: CableRouting; label: string; Icon: React.FC }> = [
    { id: 'straight', label: 'Straight', Icon: StraightIcon },
    { id: 'flexi', label: 'Flexi', Icon: FlexiIcon },
  ];

  return (
    <div
      data-cable-routing-popover="true"
      className="absolute top-full left-1/2 -translate-x-1/2 mt-1 z-[60] pointer-events-auto"
    >
      <div className="bg-slate-800/95 text-white rounded-md shadow-lg border border-slate-700 p-0.5 flex gap-0.5">
        {options.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onSelect(id)}
            className="flex flex-col items-center justify-center gap-0.5 w-10 h-10 rounded-md text-[10px] font-medium leading-none text-slate-300 bg-transparent hover:bg-slate-700/80 hover:text-slate-100 transition-colors"
          >
            <span className="text-current">
              <Icon />
            </span>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
